import { createConfigExperiment, Experiment } from '@pegasus/abtesting';

const PROJECT_ID = '04409309-bf2b-405f-83a0-1f8ddcacc6b0';
const CROSS_CAMPAIGN_A_VARIANT = 'control_ccf_off';
const CROSS_CAMPAIGN_B_VARIANT = 'variant_ccf_on';

export const isCrossCampaignVariant = (experiments: Record<string, Experiment>) => {
    if (!experiments) {
        return false;
    }

    const experiment = experiments[PROJECT_ID];

    return experiment?.variant === CROSS_CAMPAIGN_B_VARIANT;
};

export default createConfigExperiment({
    projectId: PROJECT_ID,
    variants: [CROSS_CAMPAIGN_A_VARIANT, CROSS_CAMPAIGN_B_VARIANT],
});
